import { z } from 'zod';
import { CPUSER_CONSTRAINTS } from '@/lib/constants/account';

export const teamMemberCreateSchema = z.object({
  username: z.string()
    .min(1, 'Username is required')
    .max(CPUSER_CONSTRAINTS.USERNAME_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.USERNAME_MAX} characters`),
  password: z.string()
    .min(CPUSER_CONSTRAINTS.PASSWORD_MIN, `Password must be at least ${CPUSER_CONSTRAINTS.PASSWORD_MIN} characters`)
    .max(CPUSER_CONSTRAINTS.PASSWORD_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.PASSWORD_MAX} characters`),
  confirmPassword: z.string().min(1, 'Confirm password is required'),
  firstName: z.string()
    .min(1, 'First name is required')
    .max(CPUSER_CONSTRAINTS.FIRST_NAME_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.FIRST_NAME_MAX} characters`),
  lastName: z.string()
    .min(1, 'Last name is required')
    .max(CPUSER_CONSTRAINTS.LAST_NAME_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.LAST_NAME_MAX} characters`),
  email: z.string()
    .min(1, 'Email is required')
    .email('Invalid email address')
    .max(CPUSER_CONSTRAINTS.EMAIL_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.EMAIL_MAX} characters`),
  phone: z.string()
    .max(CPUSER_CONSTRAINTS.PHONE_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.PHONE_MAX} characters`),
  ingestcfgId: z.number().nullable(),
}).refine(data => data.password === data.confirmPassword, {
  message: 'Passwords do not match',
  path: ['confirmPassword'],
});

export type TeamMemberCreateFormValues = z.infer<typeof teamMemberCreateSchema>;

export const teamMemberEditSchema = z.object({
  firstName: z.string()
    .min(1, 'First name is required')
    .max(CPUSER_CONSTRAINTS.FIRST_NAME_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.FIRST_NAME_MAX} characters`),
  lastName: z.string()
    .min(1, 'Last name is required')
    .max(CPUSER_CONSTRAINTS.LAST_NAME_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.LAST_NAME_MAX} characters`),
  email: z.string()
    .min(1, 'Email is required')
    .email('Invalid email address')
    .max(CPUSER_CONSTRAINTS.EMAIL_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.EMAIL_MAX} characters`),
  phone: z.string()
    .max(CPUSER_CONSTRAINTS.PHONE_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.PHONE_MAX} characters`),
  ingestcfgId: z.number().nullable(),
});

export type TeamMemberEditFormValues = z.infer<typeof teamMemberEditSchema>;

export const passwordResetSchema = z.object({
  newPassword: z.string()
    .min(CPUSER_CONSTRAINTS.PASSWORD_MIN, `Password must be at least ${CPUSER_CONSTRAINTS.PASSWORD_MIN} characters`)
    .max(CPUSER_CONSTRAINTS.PASSWORD_MAX, `Cannot exceed ${CPUSER_CONSTRAINTS.PASSWORD_MAX} characters`),
  confirmPassword: z.string().min(1, 'Confirm password is required'),
}).refine(data => data.newPassword === data.confirmPassword, {
  message: 'Passwords do not match',
  path: ['confirmPassword'],
});

export type PasswordResetFormValues = z.infer<typeof passwordResetSchema>;
